import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Typography } from '@mui/material';
import { di } from '../../../state/inversify.config';
import { CreateIncidentDomainService } from '../createIncidentDomainService';
import { AuthService } from '../../../state/helperServices/auth/auth.service';
import { RedFlagItem } from '../dumb/redFlagItem';
import { Button } from '../../../components/button/button';

export function CheckRedFlagsSmart() {
  const { t } = useTranslation();

  const incidentDomainService = di.get<CreateIncidentDomainService>(
    CreateIncidentDomainService,
  );

  // TODO: move into a domainService and only return accountType or even better find a way so that you don't have to send down the accountType
  const authService = di.get<AuthService>(AuthService);
  const loggedInUser = authService.useLoggedInUserSelector();

  const incidentCreationSelector =
    incidentDomainService.useIncidentCreateViewSelector();
  const player = incidentDomainService.useSelectedPlayerSelector();

  const onIncidentCreation = (redFlags?: boolean) => {
    incidentDomainService.dispatchIncidentCreation({
      ...incidentCreationSelector,
      incidentDateTime: new Date().toString(),
      redFlags,
    });
  };

  useEffect(() => {
    onIncidentCreation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const flagKeys = [
    'CHECK_FLAGS_NECK_PAIN',
    'CHECK_FLAGS_SEIZURE_CONVULSION',
    'CHECK_FLAGS_DOUBLE_VISION',
    'CHECK_FLAGS_LOSS_CONSCIOUSNESS',
    'CHECK_FLAGS_WEAKNESS_TINGLING',
    'CHECK_FLAGS_DETERIORATING_CONSCIOUSNESS',
    'CHECK_FLAGS_VOMITING',
    'CHECK_FLAGS_SEVERE_HEADACHE',
    'CHECK_FLAGS_INCREASINGLY_RESTLESS',
    'CHECK_FLAGS_GCS_LESS_THAN_15',
    'CHECK_FLAGS_VISIBLE_SKULL_DEFORMITY',
  ];

  return (
    <Box sx={{ m: 1 }}>
      <Grid container rowGap={1}>
        <Typography variant="subtitle1">{t('CHECK_FLAGS_TITLE')}</Typography>
        {flagKeys.map((k) => {
          return <RedFlagItem key={k} flagKey={k} />;
        })}
        <Typography variant="body1" sx={{ mt: 1 }} fontWeight="bold">
          {t('CHECK_FLAGS_QUESTION', { firstName: player?.firstName })}
        </Typography>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={4}>
            <Button
              type="submit"
              testId="yesResponse"
              color={incidentCreationSelector?.redFlags ? 'secondary' : 'info'}
              variant={
                incidentCreationSelector?.redFlags ? 'contained' : 'outlined'
              }
              onClick={() => {
                onIncidentCreation(true);
              }}
              fullWidth
              label={t('CHECK_FLAGS_YES')}
            />
          </Grid>
          <Grid item xs={4}>
            <Button
              type="submit"
              testId="noResponse"
              color={
                !incidentCreationSelector?.redFlags &&
                incidentCreationSelector?.redFlags !== undefined
                  ? 'secondary'
                  : 'info'
              }
              variant={
                !incidentCreationSelector?.redFlags &&
                incidentCreationSelector?.redFlags !== undefined
                  ? 'contained'
                  : 'outlined'
              }
              onClick={() => {
                onIncidentCreation(false);
              }}
              fullWidth
              label={t('CHECK_FLAGS_NO')}
            />
          </Grid>
          {incidentCreationSelector?.redFlags && (
            <Typography
              variant="body1"
              color="red"
              sx={{ mt: 1 }}
              fontWeight="bold"
            >
              {t('CHECK_FLAGS_MEDICAL_HELP')}
            </Typography>
          )}
          {!incidentCreationSelector?.redFlags &&
            incidentCreationSelector?.redFlags !== undefined && (
              <Typography variant="body1" sx={{ mt: 1 }}>
                {t('CHECK_FLAGS_THANKS', {
                  name: `${loggedInUser?.firstName} ${loggedInUser?.lastName}`,
                })}
              </Typography>
            )}
        </Grid>
      </Grid>
    </Box>
  );
}
